import * as React from "react";
import { Flex, Box } from "reflexbox";
import Layout from "../components/layout";
import SocialNav from "../components/layout/SocialNav";
import ContactForm from "../features/ContactForm/ContactForm";
import {
  Center,
  H1,
  H2,
  LI,
  UL,
} from "../components/typography/styled/typography";
import SEO from "../components/seo";
import { Container } from "../components/layout/container";
import { Link } from "gatsby";
import Img from "gatsby-image";
import { graphql } from "gatsby";
import { Contact } from "../styled/contact";
import { Ornament } from "../components/layout/ornament";
import { Lang, Translate, TranslateSwitch } from "../components/tr";
import { LangLink } from "../components/lang-link";

const imgstyle = { maxWidth: "100%" };

const ContactPage = ({ data, pageContext: { lang = Lang.cs }, location }) => (
  <Layout lang={lang} location={location}>
    <SEO
      lang={lang}
      title="Contact me"
      description={"Order your own nature landscape painting"}
    />
    <Container>
      <Ornament />
      <Center>
        <H1>
          <Translate text={"Paint me the story of my heart"} />
        </H1>
        <Flex justifyContent={"center"}>
          <Box width={[1, 3 / 5, 3 / 5]}>
            <TranslateSwitch
              en={
                <p>
                  You have an idea, thought, your perfect image or strong
                  feeling which you would love to get real shape. I'll help you
                  to tune in the idea, design it or I'll choose reference
                  picture you love. The result will be your original painting.
                  <br />
                  <br />
                  Use the form to{" "}
                  <strong>bring me near your imagination</strong>. I'll send you
                  in return <strong>shaped idea</strong> into clear picture and
                  what could be your price. <strong>Then you can decide</strong>
                  .
                  <br />
                  See also my galleries (
                  <LangLink to={"/oil-gallery"}>oil</LangLink>,{" "}
                  <Link to={"/oil-watercolor"}>watercolor</Link>) for
                  imformative prices.
                </p>
              }
              cs={
                <p>
                  Máš představu, myšlenku, svůj dokonalý obraz nebo silný pocit,
                  který chceš aby dostal reálnou podobu. Pomůžu ti tvůj nápad
                  doladit do konce,{" "}
                  <strong>
                    navrhnout nebo pomoci s výběrem předlohy nebo motivu
                  </strong>
                  . Výsledek bude <strong>tvůj originální obraz</strong>.
                  <br />
                  <br />
                  Tvůj nápad mi prosím přibliž skrz následující formulář nebo
                  e-mail. Obratem ti pošlu přibližnou cenu a můj detailnější
                  návrh na realizaci.{" "}
                  <strong>
                    Pak se můžeš rozhodnout, jestli do toho půjdeš
                  </strong>
                  .
                </p>
              }
            />
          </Box>
        </Flex>
      </Center>
      <Flex flexWrap={"wrap"} style={{ marginTop: 15 }}>
        <Box width={[1, 1, 3 / 5]} py={[3, 3, 2]}>
          <ContactForm
            recaptchaKey={"6Le-9nQUAAAAABSeZRmb6L8nnTpimXXod_kLJVDO"}
          />
        </Box>
        <Box width={[1, 1, 2 / 5]} py={[3, 3, 4]} px={[3, 3, 3, 5, 5]}>
          <Contact>
            Pavlína Ostrá
            <br />
            Jablonec nad Nisou
            <br />
            <a href={"mailto:paaveart@gmail.com"}>paaveart@gmail.com</a>
            <br />
            <br />
            Instagram: @paave.art
            <br />
            FB: @paaveart
            <br />
          </Contact>
          <SocialNav />
        </Box>
      </Flex>
      <Flex flexWrap={"wrap"}>
        <Box
          width={[1, 1, 3 / 5]}
          py={[0, 3, 4]}
          px={[2, 0, 0]}
          pr={[3, 3, 5, 5, 5]}
        >
          <H2 id={'#my-story'}>
            <Translate text={"My story"} />
          </H2>
          <TranslateSwitch
            en={
              <>
                <p>As a little girl I didn’t have careless childhood. A lot of situations was quite complicated and we didn’t  belong among wealthy families. But even though I realized I could feel better and then it started a misson for happy life.</p>
                <p>I read once if I have something pretty in front of my eyes even it should be daisy in the glass so it helps me to feel well. Since then I had been thinking about it.</p>

                <p>At the moment I changed my view and I started to think what to have around me and how can I do it. Later there were posters of my favorite music bands and then I was staring on them for so long until I desired to draw them, to express what I can see in their faces. And so I had started to turn into drawings my deep feelings  which nobody has no clue about . And from black and white they became colored. Up to once I discovered oil paints which I fell in love with completely. At that moment I understood there is no way back and what was only hobby became my life purpose. To catch beauty or feelings around, to my picture. I understood this is important part of me, my essence and maybe one of the reasons why I’m here on the Earth.</p>

                <p>Every brush stroke compensated hours of therapies I would need to be what I’m without a shame. From the angry and scattered person hard skin peeled off and I’ve started to integrate my sensitive part until I realized I belong to hypersensitive people. This reality helped to perceive as an advantage and I can use these abilities in artistic creations.</p>
              </>
            }
            cs={
              <>
              <p>Jako malá holka jsem neměla úplně ideální dětství. Mnoho věcí bylo komplikovaných, nepatřili jsme mezi movité rodiny. Ale už jako malá jsem si uvědomovala, že bych se přeci jen mohla cítit lépe a už tehdy začala má mise za šťastným životem.</p>
              <p>Jednou jsem si někde přečetla, že aby se člověk cítil dobře, stačí pár jednoduchých věcí, jako třeba mít na očích pořád něco krásného, i kdyby to měla být sedmikráska ve sklenici. </p>

              <p>A v tu chvíli se mi změnil pohled a já se začala obklopovat hezkými jednoduchými věcmi a obrázky. Později to byly plakáty mých oblíbených hudebních skupin, na které jsem koukala tak dlouho, dokud jsem nezatoužila je umět nakreslit. A tak jsem začala proměňovat své hluboké pocity, o kterých nikdo nevěděl, do kreseb.</p>
              <p>A z černobarevných se stávaly barevné. Až jsem jednou objevila olejové barvy, kterým jsem naprosto propadla. A v tu chvíli jsem pochopila, že není cesty zpět a co dříve bylo jen koníčkem, stalo se životním posláním, zachytit tu krásu kolem do svého obrazu. Pochopila jsem, že obrazové vyjádření je moje důležitá část, součást mé podstaty, možná jeden z důvodů, proč na téhle Zemi jsem.</p>

              <p>Každý tah štětcem vynahradil hodiny terapie a z roztěkaného a naštvaného člověka se odlupovala ztvrdlá slupka, začala jsem objevovat svou jemnou stránku až jsem si jednoho dne uvědomila, že patřím mezi hypersenzitivní lidi. Tato skutečnost mi pomohla svou jemnost začít vnímat jako výhodu, nikoliv jako prokletí, a že mohu tyto vlastnosti využívat právě při umělecké tvorbě.</p>
              </>
            }
          />

          <h3>
            <Translate text={"More about me"} />
          </h3>
          <UL>
            <LI>
              <Link to={"/blog/jsem-hypersensitivni/"}>
                Jsem hypersensitivní. No a co?
              </Link>
            </LI>
            <LI>
              <Link to={"/blog/zamysleni-nad-leonardem-da-vinci/"}>
                Kdo že je ten můj malířský vzor
              </Link>
            </LI>
            <LI>
              <Link to={"/blog/co-pro-me-znamena-umeni-obrazotvornost/"}>
                Příběh obrazu "Night Never Ending"
              </Link>
            </LI>
          </UL>
        </Box>
        <Box
          width={[1, 1, 2 / 5]}
          px={[0, 3, 0]}
          pt={[0, 5, 5]}
          style={{ textAlign: "center" }}
        >
          <Img
            fixed={data.file.childImageSharp.fixed}
            alt="Pavlina Ostra"
            style={imgstyle}
          />
        </Box>
      </Flex>
    </Container>
  </Layout>
);

export default ContactPage;

export const query = graphql`
  query getAboutData {
    file(relativePath: { eq: "profile.png" }) {
      childImageSharp {
        fixed(width: 500, height: 666, quality: 90) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`;
